import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import WelcomePanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createWelcomeScreen = () => {
  const root = createRoot(document.getElementById('welcomePanel'));
  if (isSupportedBrowser()) {
    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <WelcomePanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createWelcomeScreen = createWelcomeScreen;
